<template lang="html">
  <section>
    <name-input
      :all-des="allDes"
      :is-ready="!loadingData"
      :should-focus="!storedDataElement.name"
      :name="storedDataElement.name"
      :de-id="storedDataElement.id"
      @on-name-input-changed="onDeNameChanged"
    ></name-input>

    <element-description
      v-if="!loadingData"
      :elem-description="storedDataElement.description"
      @on-element-description-changed="onDeDescriptionChanged"
    ></element-description>

    <div class="crm-fields-container" v-if="!loadingData">
      <label class="query-label">
        {{ getMessageText(messages.OBJECT) }}
      </label>
      <div class="obj-select">
        <b-form-select
          v-if="!fetchObjectsFailed"
          v-model="storedDataElement.selectedObject"
          :options="objects"
          @change="onObjectChange"
          size="sm"
        ></b-form-select>

        <button
          v-if="fetchObjectsFailed"
          class="modal-btn modal-save-btn retry-btn no-user-select"
          :disabled="loadingData"
          @click="describeObjects"
        >
          {{ getMessageText(messages.RETRY) }}
        </button>
      </div>
    </div>

    <div
      class="crm-fields-container ctx-fields-list"
      v-if="!loadingData && !fetchObjectsFailed"
    >
      <label class="query-label" v-if="fieldsReady">
        {{ $t("fields") }}
      </label>
      <div class="fields-search" v-if="fieldsReady">
        <multiselect
          v-if="!fetchFieldsFailed"
          v-model="storedDataElement.selectedField"
          :options="fieldsForMultiSelect"
          label="label"
          track-by="name"
          @select="onMultiSelect"
        >
          <template slot="singleLabel" slot-scope="props">
            <span class="selected-icon">
              <svg class=" slds-icon_container slds-icon--x-small">
                <use :xlink:href="getUtilityIcon(props.option)"></use>
              </svg>
            </span>
            <div class="option-label">{{ props.option.label }}</div>
          </template>
          <template slot="option" slot-scope="props">
            <span class="fields-icon">
              <svg class=" slds-icon_container slds-icon--small">
                <use :xlink:href="getUtilityIcon(props.option)"></use>
              </svg>
            </span>
            <div
              class="option-row"
              v-b-tooltip.hover
              :title="props.option.description"
            >
              <div class="option-label">
                <div class="option-left">
                  {{ getMessageText(messages.LABEL) }}:
                </div>
                <div>{{ props.option.label }}</div>
              </div>
              <div class="option-dev-name">
                <div class="option-left">
                  {{ getMessageText(messages.API_NAME) }}:
                </div>
                <div>{{ props.option.name }}</div>
              </div>
              <div class="option-type">
                <div class="option-left">
                  {{ getMessageText(messages.TYPE) }}:
                </div>
                <div>{{ props.option.dataType }}</div>
              </div>
            </div>
          </template>
        </multiselect>
        <button
          v-if="fetchFieldsFailed"
          class="modal-btn modal-save-btn retry-btn no-user-select"
          :disabled="loadingData"
          @click="describeSelectedObject(storedDataElement.object)"
        >
          {{ getMessageText(messages.RETRY) }}
        </button>
      </div>
    </div>

    <div class="loader" v-if="loadingData"></div>
  </section>
</template>

<script lang="js">
  import { mapState, mapActions } from "vuex";
  import SfGlobalObjects from "@/utils/sf-global-objects";
  import { MUTATION_NAME, ENTRY_POINT_OBJECTS_MAPPING } from "@/static/global-variables";
  import utils from "@/utils";
  import "vue-multiselect/dist/vue-multiselect.min.css";
  import Multiselect from "vue-multiselect";
  import NameInput from "@/components/NameInput";
  import ElementDescription from "@/components/ElementDescription";
  import iconsUri from "@/views/drag-drop-pages/components/utils/icons-uri";

  export default  {
    name: "context-edit",
    components: {
      Multiselect,
      NameInput,
      ElementDescription
    },
    props: {
      appId: String,
      appType: String,
      de: Object,
      id: String,
      name: String,
      allDes: Object
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      fieldsForMultiSelect() {
        return this.fields.filter(field => {
          return !field.hideFromMultiSelect;
        });
      },
      fieldsReady() {
        return Boolean(this.fields.length);
      },
      loadingData() {
        return this.loadingObjects || this.loadingSelectedObject;
      }
    },
    mounted () {
      this.init();
    },
    data () {
      return {
        storedDataElement: {
          appId: this.appId,
          description: this.de.description,
          id: this.de.id,
          type: this.de.type,
          name: this.de.name,
          object: this.de.object,
          selectedObject: null,
          selectedField: null
        },
        fields: [],
        objects: [],
        loadingObjects: false,
        loadingSelectedObject: false,
        fetchObjectsFailed: null,
        fetchFieldsFailed: null
      }
    },
    methods: {
      ...mapActions({
        setDataElement: MUTATION_NAME.SET_EDIT_DATA_ELEMENT
      }),
      init() {
        const objName = this.storedDataElement.object;
        this.describeObjects(objName);
        const keys = this.de.fields? Object.keys(this.de.fields) : [];
        if (keys.length) {
          const fieldName = keys[0];
          const contextField = this.de.fields[fieldName];
          this.storedDataElement.selectedField = {
            name: fieldName,
            type: contextField.dataType,
            dataType: contextField.dataType,
            label: contextField.label
          };
          this.describeSelectedObject(objName);
          this.setDataElement(this.storedDataElement);
        } else {
          if (objName) {
            this.describeSelectedObject(objName);
          } else {
            this.fields = [];
          }
        }
      },

      describeObjects(objName) {
        this.loadingObjects = true;
        SfGlobalObjects.describeObjects(ENTRY_POINT_OBJECTS_MAPPING[this.appType.replace(/ /g, "_")]).then(
          resps => {
            this.objects = Object.keys(resps).map(key => {
              return {
                value: {
                  name: resps[key].name,
                  label: resps[key].label
                },
                fields: resps[key].fields,
                text: resps[key].label
              };
            });
            const obj = objName? this.objects.find(e => e.value.name === objName) : null;
            if(obj) {
              this.storedDataElement.selectedObject = {
                name: obj.value.name,
                label: obj.value.label
              };
              this.setDataElement(this.storedDataElement);
            }
            this.loadingObjects = false;
          },
          () => {
            this.fetchObjectsFailed = true;
            this.loadingObjects = false;
            this.displayFetchError();
          }
        );
      },
      displayFetchError() {
        this.$bvToast.toast(
          this.getMessageText(this.messages.SFDC_METADATA_ERROR),
          {
            solid: true,
            toaster: "b-toaster-bottom-center",
            variant: "danger"
          }
        );
      },
      describeSelectedObject(objName) {
        this.loadingSelectedObject = true;
        SfGlobalObjects.describeObject(objName).then(
          resp => {
            SfGlobalObjects.fetchObjectMetaData(objName).then(
              meta => {
                this.fields = utils.mergeMetadataIntoFields(
                  resp.fields,
                  meta.records,
                  false
                );
                this.loadingSelectedObject = false;
              },
              () => {
                this.loadingSelectedObject = false;
                this.fetchFieldsFailed = true;
                this.displayFetchError();
              }
            );
          },
          () => {
            this.loadingSelectedObject = false;
            this.fetchFieldsFailed = true;
            this.displayFetchError();
          }
        );
      },

      onMultiSelect(selected) {
        this.storedDataElement.selectedField = selected;
        this.setDataElement(this.storedDataElement);
      },

      onObjectChange() {
        if (this.storedDataElement.selectedObject) {
          this.storedDataElement.selectedField = null;
          this.describeSelectedObject(this.storedDataElement.selectedObject.name);
        } else {
          this.fields = [];
        }
        this.setDataElement(this.storedDataElement);
      },
      onDeNameChanged(isValidName, nameInput) {
        this.storedDataElement.name = nameInput;
        this.$emit("on-de-name-changed", isValidName);
      },
      onDeDescriptionChanged(input) {
        this.storedDataElement.description = input;
      },
      getUtilityIcon(field) {
        return iconsUri.getUtilityIconByType(field.type);
      }
    }
  }
</script>

<style scoped lang="scss">
  .fields-search {
    flex: 3;
  }

  .option-row {
    font-size: 0.75rem;
  }

  .fields-icon {
    float: left;
    height: 100%;
    padding-block: inherit;
    margin-right: 1rem;
  }

  .selected-icon {
    float: left;
    height: 100%;
    padding-block: inherit;
    margin-right: 4px;
  }

  .option-label,
  .option-dev-name,
  .option-type {
    display: flex;
  }

  .option-left {
    flex-basis: 25%;
  }

  .option-dev-name,
  .option-type {
    margin-top: 0.25rem;
  }
</style>
